import React, { useEffect, useState, useRef } from "react";
import { optionsBranch } from "../data/branch-data";
import { internType } from "../data/interntype-data";
import { thaiMonth } from "../data/month-thai";
import {
  convertDateThai,
  converToThaiNumber,
  matchOptions,
  parseDate,
} from "../utils/function";
import Barcode from "react-barcode";
import { useSelector } from "react-redux";
import { useReactToPrint } from "react-to-print";
import "../react-print.css";

const FormReviewCompleted = ({ data }) => {
  const profile = useSelector((state) => state.profileReducer.profile);
  const [onReadOnly, setReadOnly] = useState(false);
  const [showPosition, setShowPosition] = useState(false);

  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const pos = data?.president_pos1.split(" ");
  const pos1 = pos.slice(0, pos.length - 1).join(" ");
  const pos2 = pos[pos.length - 1];

  useEffect(() => {
    if (data.idm_status != 1) {
      setReadOnly(true);
    }
  }, [data]);

  const displayContent = (
    <section
      className="sheet   print-container react-print-container"
      style={{ color: "black" }}
      id="section-to-print"
      ref={componentRef}
    >
      <div>
        <div style={{ color: "black" }}>
          <div className="">
            <div className="col-12 text-center" style={{ height: "22mm" }}>
              <img
                src="./assets/images/buu-logo-2.png"
                alt="buu logo"
                width="100px"
              />
            </div>
            <div className="row">
              <div className="col-7 mb-3">
                <div>
                  ที่ อว ๘๑๑๖/
                  <input
                    readOnly={onReadOnly}
                    style={{ width: "50px" }}
                    type="text"
                    className="input-form border-0 text-start"
                    name="idm_docnum"
                    defaultValue={data?.idm_docnum}
                  />
                </div>
              </div>
              <div className="col-5 mb-3 d-flex justify-content-end">
                <div>
                  <div>คณะวิศวกรรมศาสตร์ มหาวิทยาลัยบูรพา</div>
                  <div>ตำบลแสนสุข อำเภอเมืองฯ</div>
                  <div>จังหวัดชลบุรี ๒๐๑๓๑</div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-6 mb-4"></div>
              <div className="col-6 ps-0 mb-4">
                <input
                  readOnly={onReadOnly}
                  style={{ width: "150px" }}
                  type="text"
                  className="input-form border-0 text-start"
                  name="idm_docdate"
                  defaultValue={data?.idm_docdate}
                />
              </div>
            </div>
            <div className="col-12 mb-3">
              <div>
                เรื่อง <span style={{ marginRight: "5mm" }} />
                ขอความอนุเคราะห์รับนิสิตฝึกงานภาคฤดูร้อนและปฎิบัติสหกิจศึกษา
              </div>
            </div>
            <div className="col-12 position-relative">
              <div>
                <span className="me-2">เรียน</span>
                <span style={{ marginRight: "5mm" }} />
                <span>
                  <input
                    readOnly={onReadOnly}
                    style={{ width: "90%" }}
                    type="text"
                    name="idm_header"
                    className=" border-0"
                    defaultValue={data?.idm_header}
                  />
                </span>
              </div>
              <span
                id="section-to-not-print"
                className="btn btn-outline-info px-2 py-0 position-absolute top-0 end-0"
                style={{ fontSize: "18px" }}
                role="button"
                unbind
                onClick={() => setShowPosition(!showPosition)}
              >
                + ตำแหน่ง
              </span>
            </div>
            {showPosition && (
              <div className="col-12 " style={{ textIndent: "55px" }}>
                <span style={{ marginRight: "1mm" }} />
                <span>
                  <input
                    readOnly={onReadOnly}
                    style={{ width: "80%" }}
                    type="text"
                    className=" border-0"
                  />
                </span>
              </div>
            )}
            <div className="col-12 mb-3" style={{ textIndent: "55px" }}>
              <div>{converToThaiNumber(data?.companyDetail?.name)}</div>
            </div>
            <div className="col-12 mb-3">
              สิ่งที่ส่งมาด้วย
              แบบฟอร์มตอบรับนิสิตเข้ารับการฝึกงานภาคฤดูร้อนและปฎิบัติสหกิจศึกษา
              จำนวน ๑ ชุด
            </div>

            <div className="col-12 mb-2" style={{ textIndent: "75px" }}>
              ตามที่คณะวิศวกรรมศาสตร์ มหาวิทยาลัยบูรพา
              ได้เปิดสอนหลักสูตรวิศวกรรมศาสตรบัณฑิต สาขาวิชาวิศวกรรมเคมี
              วิศวกรรมเครื่องกล วิศวกรรมไฟฟ้า วิศวกรรมโยธา วิศวกรรมอุตสาหการ
              วิศวกรรมสิ่งแวดล้อม วิศวกรรมระบบสมองกลฝังตัว และวิศวกรรมวัสดุ
              โดยกำหนดให้นิสิตชั้นปีที่ ๓ ขึ้นไป เข้ารับการฝึกประสบการณ์
              <br />
              เกี่ยวกับวิชาชีพในแต่ะละสาขาวิชา ในหน่วยงาน{" "}
              <span className="text-nowrap">ภาครัฐ</span> ภาคเอกชน
              และโรงงานอุตสาหกรรมต่าง ๆ
              เพื่อให้นิสิตได้เรียนรู้และหาประสบการณ์ตรงในวิชาชีพตามหลักสูตร
              ในช่วงระยะเวลาที่กำหนดทุกภาคการศึกษา
            </div>
            <div className="col-12 mb-2" style={{ textIndent: "75px" }}>
              เพื่อให้การฝึกงานภาคฤดูร้อนและปฎิบัติสหกิจศึกษา
              ในปีการศึกษานี้เป็นไปด้วยความเรียบร้อย
              <br />
              คณะวิศวกรรมศาสตร์ มหาวิทยาลัยบูรพา
              จึงขอความอนุเคราะห์หน่วยงานของท่านรับนิสิตเข้า
              <span className="">
                {converToThaiNumber(
                  matchOptions(internType, data?.type_intern)
                )}
              </span>{" "}
              ตั้งแต่
              <span className="text-nowrap">วันที่</span>
              {convertDateThai(data?.idm_start_date, true)} ถึง วันที่
              {convertDateThai(data?.idm_end_date, true)} จำนวน{" "}
              {converToThaiNumber(data?.internStd?.length)} คน ดังนี้
            </div>

            <div className="col-12">
              {data?.internStd?.length &&
                data?.internStd?.map((std, index) => {
                  const levelRaw =
                    +std?.internStudent?.school_yrs?.slice(-2) +
                    1 -
                    +std?.internStudent?.id.slice(0, 2);
                  const level = levelRaw <= 4 ? levelRaw : 4;

                  return (
                    <div
                      className="row"
                      style={{ margin: "0 auto" }}
                      key={index}
                    >
                      <div className="col-6" style={{ textIndent: "50px" }}>
                        {converToThaiNumber(index + 1)}){" "}
                        {std?.internStudent?.name}
                      </div>
                      <div className="col-6">
                        นิสิตปีที่ {converToThaiNumber(level)} สาขาวิชา{" "}
                        {matchOptions(optionsBranch, std?.internStudent?.b_id)}
                      </div>
                      <input
                        readOnly={onReadOnly}
                        className="d-none"
                        name="groupStd[]"
                        value={std.id}
                      />
                    </div>
                  );
                })}
            </div>
            <div className="col-12 mt-3" style={{ textIndent: "75px" }}>
              จึงเรียนมาเพื่อโปรดพิจารณาให้ความอนุเคราะห์ จักขอบคุณยิ่ง
            </div>
            <div className="col-12 mt-3 d-flex justify-content-end">
              <div className="text-center" style={{ paddingRight: "39mm" }}>
                <div>ขอแสดงความนับถือ</div>
                <div style={{ height: "15mm" }} />
                <div>
                  <div>
                    <input
                      readOnly={onReadOnly}
                      style={{ width: "300px" }}
                      name="president"
                      type="text"
                      className="input-form border-0 text-center"
                      defaultValue={data?.president}
                    />
                  </div>
                  <div>
                    <input
                      readOnly={onReadOnly}
                      style={{ width: "300px" }}
                      name="president_pos1"
                      type="text"
                      className="input-form border-0 text-center"
                      defaultValue={pos1}
                    />
                  </div>
                  <div>
                    <input
                      readOnly={onReadOnly}
                      style={{ width: "300px" }}
                      name="president_pos2"
                      type="text"
                      className="input-form border-0 text-center"
                      defaultValue={pos2}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* {data?.internStd?.length >= 6 && <div className="page-break" />} */}

            <div className="row">
              <div className="col-6">
                <div>สำนักงานคณบดี </div>
                <div>โทร. ๐ ๓๘๑๐ ๒๒๒๒ ต่อ ๓๓๑๕, ๓๓๒๔ </div>
                <div>ไปรษณีย์อิเล็กทรอนิกส์ co-op@eng.buu.ac.th</div>
              </div>
              <div className="col-6 d-flex align-items-end justify-content-end">
                <Barcode
                  value={data?.idm_doc_id}
                  width={1.5}
                  height={30}
                  fontSize={10}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <input
        readOnly={onReadOnly}
        name="idm_doc_id"
        value={data?.idm_doc_id}
        className="d-none"
      />
    </section>
  );

  return (
    <div className="position-relative">
      <form action="./update-document-internship.php" method="post">
        <div
          style={{
            position: "absolute",
            top: "20px",
            right: "20px",
            zIndex: 99,
          }}
        >
          <div className="btn btn-primary btn-sm" onClick={handlePrint}>
            พิมพ์เอกสาร
          </div>
          {!onReadOnly && (
            <button type="submit" className="btn btn-sm btn-primary mx-2">
              Save
            </button>
          )}
        </div>

        {displayContent}
      </form>
    </div>
  );
};

export default FormReviewCompleted;
